import { getBackgroundColor, getBorderColor, getIconColor } from "../../../customStyles/common";

const defineAlertStyle = (severity: string, sessionExpired: string | null) => {
    const alertStyle = {
        backgroundColor: getBackgroundColor(severity),
        mb: '1rem',
        borderColor: getBorderColor(severity),
        border: `1px solid`,
        '.MuiAlert-icon': {
            color: getIconColor(severity),
        },
        '& .MuiAlert-action': {
            color: sessionExpired ? 'warning.contrastText' : '',
        },
        width: '100%'
    };

    return alertStyle
}

export { defineAlertStyle } 